<template>
<div class="form-submission-card-subheader">
    <div class="form-submission-card-subheader-content d-flex justify-content-between">
        <div class="form-submission-card--group d-flex">
            <submission-signature-button
                v-if="!pdf_mode"
                :signature="signature"
                @open-signature="$emit('open-signature')"
            />
            <div>
                <div
                    class="form-submission-card-subheader-child"
                    v-html="subtitle_line_1_computed"
                ></div>

                <div
                    class="form-submission-card-subheader-child"
                    v-html="subtitle_line_2_computed"
                ></div>
            </div>
        </div>

        <submission-inline-signature
            v-if="pdf_mode && signature"
            :signature="signature"
        />
    </div>
</div>
</template>

<script>
import SubmissionSignatureButton from '../submissions/SubmissionSignatureButton';
import SubmissionInlineSignature from '../submissions/SubmissionInlineSignature';

export default {
    components: {
        SubmissionSignatureButton,
        SubmissionInlineSignature,
    },
    emits: ['open-signature'],
    props: {
        signature: {
            type: Object,
            required: false,
        },
        form_status: {
            type: Object,
        },
        subtitle_line_1: {
            type: String,
            default: null,
        },
        subtitle_line_2: {
            type: String,
            default: null,
        },
        pdf_mode: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        subtitle_line_1_computed() {
            return this.subtitle_line_1 ?? this?.form_status?.subtitle_line_1 ?? '';
        },
        subtitle_line_2_computed() {
            return this.subtitle_line_2 ?? this?.form_status?.subtitle_line_2 ?? '';
        },
    },
};
</script>
